import { InjectionToken, Inject, Injectable } from '@angular/core';

export interface DeeplinkMappings {
  [path: string]: (...parts: string[]) => string;
}

export const DEEPLINK_MAPPINGS = new InjectionToken<DeeplinkMappings>('mappings for deeplink urls');

@Injectable({ providedIn: 'root' })
export class DeeplinkMapper {
  constructor(
    @Inject(DEEPLINK_MAPPINGS)
    private mappings: DeeplinkMappings
  ) {}

  mapLocation(path: string) {
    if (path == null) {
      return undefined;
    }

    const parts = path.split('#');
    if (parts.length !== 2) {
      return undefined;
    }

    return this.mapHash(parts[1]);
  }

  private mapHash(hash: string) {
    const deeplink = this.extractHash(hash);
    if (deeplink == null) {
      return undefined;
    }

    const parts = deeplink.split('/');
    if (parts.length === 0) {
      return undefined;
    }

    const mapping = this.mappings[parts[0]];
    if (mapping == null) {
      return undefined;
    }

    return mapping(...parts.slice(1));
  }

  private extractHash(hash: string) {
    if (hash == null) {
      return undefined;
    }

    const directives = hash.split(';');
    const deeplink = directives.find((d) => d.startsWith('deeplink='));
    if (deeplink == null) {
      return undefined;
    }

    const parts = deeplink.split('=');
    return parts[1];
  }
}
